import { Box, CardMedia, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import ImageGalleryCard from "./Shared/ImageGalleryCard";
import ImagesGallerySelection from "./Shared/ImagesGallerySelection";
import { useBrowseMyGenerations } from "../../../store/Apis/SuitesApps/ImageSuitesApi";
import EmptySuiteHistory from "../../VideoSuite/VideoSuiteHistory/Components/EmptySuiteHistory";
import { Dayjs } from "dayjs";

interface MyGenerationsImagesProps {
  setImageSourceSelected: (image: File | string | null) => void;
  dateFilter?: string | null;
}

const MyGenerationsImages = ({
  setImageSourceSelected,
  dateFilter,
}: MyGenerationsImagesProps) => {
  const { data: myGenerationImagesData, isLoading } = useBrowseMyGenerations({
    createdAt: dateFilter ? dateFilter : null,
    itemsPerPage: null,
    page: null,
  });
  
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        overflow: "hidden",
      }}
    >
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexGrow: 1,
          }}
        >
          <CircularProgress size={50} color="primary" />
        </Box>
      ) : myGenerationImagesData && myGenerationImagesData.length > 0 ? (
        <ImagesGallerySelection
          imagesData={myGenerationImagesData ?? []}
          setImageSourceSelected={setImageSourceSelected}
        />
      ) : (
        <EmptySuiteHistory
          suiteRouting="/suites/image-suite"
          suiteClass="empty-image-history-image"
          suiteHeader="No Images found"
          suiteMessage="Your uploaded images will appear here"
          removeButton
        />
      )}
    </Box>
  );
};

export default MyGenerationsImages;
